<template>
  <div v-if="this.$route.name !== 'digital-expenses-promo'" class="success-page-wrapper d-flex align-items-center justify-content-center">

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6">

          <div class="user-info text-center text-white mb-4 animate-fade-in">
            <h4 class="font-weight-bold mb-3">{{ ownerAssociation.administration }}</h4>
            <div class="welcome-text opacity-90">
              <p class="mb-1">Bienvenido: <span class="font-weight-bold">{{ ownerAssociation.functional_unit_owners }}</span></p>
              <p class="mb-0">{{ ownerAssociation.owners_association_name }}</p>
            </div>
          </div>

          <div class="card border-0 shadow-lg animate-card">
            <div class="card-body text-center p-5">

              <div class="checkmark-wrapper mb-4">
                <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                  <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                  <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
              </div>

              <h3 class="mb-3 font-weight-bold text-dark">¡Gracias por su respuesta!</h3>

              <p class="text-muted mb-4 text-message">
                La operación se realizó con éxito.
                <br>
                <span class="text-success font-weight-bold">Desde la próxima liquidación recibirá las expensas digitalmente.</span>
              </p>

              <p class="text-dark mb-0 small">Muchas gracias por colaborar con el medio ambiente.</p>
            </div>

            <div class="card-footer bg-transparent border-0 text-center pb-4">
              <img src="@/assets/img/idata.svg" class="idata-profile opacity-50" alt="idata-profile-pic">
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SuccessMessage',
  props: ['ownerAssociation'],
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
  },
};
</script>

<style lang='scss' scoped>
.success-page-wrapper {
  background-color: #002639;
  min-height: 100vh;
  width: 100%;
  padding: 20px;
}

.card {
  border-radius: 1rem;
  overflow: hidden;
}

.text-message {
  font-size: 1.1rem;
  line-height: 1.5;
}

.opacity-90 { opacity: 0.9; }
.opacity-50 { opacity: 0.5; }

.idata-profile {
  max-width: 90px;
  height: auto;
}

.animate-fade-in {
  animation: fadeIn 0.8s ease-out forwards;
}

.animate-card {
  animation: fadeInUp 0.6s ease-out 0.2s forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.checkmark-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.checkmark {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px #7ac142;
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #7ac142;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% { stroke-dashoffset: 0; }
}

@keyframes scale {
  0%, 100% { transform: none; }
  50% { transform: scale3d(1.1, 1.1, 1); }
}

@keyframes fill {
  100% { box-shadow: inset 0px 0px 0px 50px #7ac142; }
}
</style>
